export const getters = {
  // Das oberste Modal auf dem Stack ist das aktuell aktive Modal
  active: (state) => (state.open.length > 0 ? state.open[0] : null),
  allOpen: (state) => state.open,
};
